import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  CropperPosition,
  Dimensions,
  ImageCroppedEvent,
  ImageTransform,
  LoadedImage,
} from 'ngx-image-cropper';
import { SharedataService } from '../common/service/sharedata.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css'],
})
export class MyProfileComponent extends BaseCtl {
  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  
  togglePassword(field: string) {
    if (field === 'old') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  public userContext: any = {};
  imagePreview: string | ArrayBuffer | null = null;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private shareService: SharedataService
  ) {
    super('', locator, route);
    var _self = this;

    locator.getPathVariable(route, function (params: any) {
      _self.form.searchParams['appId'] = params['appId'];
    });

    // Set userContext in new varible
    _self.locator.config
      .getProperty('endpoint.user')
      .then((property: string) => {
        _self.initApiEndpoint(property);
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';

        // Get UserContext from localstorage
    const obj: any | null = JSON.parse(
      localStorage.getItem(keySuffix + 'userContext') ?? '{}'
    );
    _self.userContext = obj;
    // Get profile details
    if (_self.userContext) {
      _self.form.data.id = _self.userContext['userId'];

          let url = property + '/profile';
          this.locator.http.get(url, function (res: any, error: boolean) {
            if (error) {
              alert('Server Error:' + error);
              return;
            }
            _self.form.error = !res.success;
            _self.form.message = res.message;
            _self.populateForm(_self.form.data, res.result.data);
            _self.form.data['roleName'] = _self.userContext['roleName'];
          });
    }

    locator.getPathVariable(route, function (params: any) {
      _self.form.searchParams['appId'] = params['appId'];
    });
      });
  }

  override preload(): void {}

  /**
   * poplate data to form
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.firstName = data.firstName;
    form.lastName = data.lastName;
    form.loginId = data.loginId;
    form.orgName = data.orgName;
    form.roleId = data.roleId;
    form.roleName = data.roleName;
    form.imageId = data.imageId;
    form.loginCode = data.loginCode;
    form.mobileId = data.mobileId;
  }

  /**
   * Get the thumbnail of the image
   * @param logo
   * @returns
   */
  getDocThumbnailImage(logo: any) {
    return this.getDocThumbnail(logo);
  }

  /**
   * Show preview of the image
   * @param event
   */
  showPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result; // Set the image preview
      };
      // reader.readAsDataURL(file); // Convert the file to base64 URL
    }
  }

  //-------------------------------------Change Passwords------------------------------------

  /**
   * Change password form
   */
  public cpForm: any = {
    error: false,
    message: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    inputerror: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
  };

  resetCpForm(){
    this.cpForm = {};
  }

  /**
   * Change the password
   *
   * @returns
   */
  changePassword() {
    let _self = this;

    if (_self.cpForm.oldPassword === _self.cpForm.newPassword) {
      _self.cpForm.error = true;
      _self.cpForm.message = 'Old and new password can not be same';
      return;
    }

    if (_self.cpForm.newPassword != _self.cpForm.confirmPassword) {
      _self.cpForm.error = true;
      _self.cpForm.message = 'New and confirm password are not matched';
      return;
    }

    _self.cpForm['loginId'] = _self.userContext['loginId'];

    let url =
      _self.locator.config.get('endpoint.login') +
      '/cp/' +
      _self.userContext['authKey'];
    _self.locator.http.post(url, _self.cpForm, function (res: any, error: any) {
      _self.cpForm.inputerror = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      };
      if (error) {
        return;
      }
      _self.cpForm.error = !res.success;
      _self.cpForm.message = res.message;

      if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
        _self.cpForm.inputerror = res.result.inputerror;
      }
    });
  }

  public override clearMessage(obj: any) {
    obj['error'] = false;
    obj['message'] = null;
  }

  // -----------------Image Crop Function--------------------------
  showCropper = false;
  loading = false;
  croppedImage: SafeUrl = '';

  imageChangedEvent: Event | null = null;
  imageURL?: string;

  hidden = false;
  disabled = false;
  alignImage = 'center' as const;
  roundCropper = false;
  backgroundColor = 'grey';
  allowMoveImage = false;
  hideResizeSquares = false;
  canvasRotation = 0;
  aspectRatio = 4 / 3;
  containWithinAspectRatio = false;
  maintainAspectRatio = false;
  cropperStaticWidth = 0;
  cropperStaticHeight = 0;
  cropperMinWidth = 0;
  cropperMinHeight = 0;
  cropperMaxWidth = 0;
  cropperMaxHeight = 0;
  resetCropOnAspectRatioChange = true;
  cropper?: CropperPosition;
  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };

  fileChangeEvent(event: Event): void {
    this.loading = true;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      event.objectUrl || event.base64 || ''
    );
    const base64 = event.base64;
    if (!base64) return;
    // Convert Base64 to File
    const file = this.base64ToFile(base64, this.imageName);
  
    this.croppedImageFile = file;
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }

  transformChange(transform: ImageTransform) {
    console.log('transform changed', transform);
  }

  rotateLeft() {
    this.loading = true;
    setTimeout(() => {
      // Use timeout because rotating image is a heavy operation and will block the ui thread
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }

  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! - 1,
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! + 1,
    };
  }

  moveDown() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! + 1,
    };
  }

  moveUp() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! - 1,
    };
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
      translateH: 0,
      translateV: 0,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  resetImage() {
    this.canvasRotation = 0;
    this.cropper = undefined;
    this.maintainAspectRatio = false;
    this.transform = {
      translateUnit: 'px',
      scale: 1,
      rotate: 0,
      flipH: false,
      flipV: false,
      translateH: 0,
      translateV: 0,
    };
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - 0.1,
    };
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + 0.1,
    };
  }

  updateRotation(rotate: number) {
    this.transform = {
      ...this.transform,
      rotate,
    };
  }

  toggleAspectRatio() {
    this.aspectRatio = this.aspectRatio === 4 / 3 ? 16 / 5 : 4 / 3;
  }

  toggleBackgroundColor() {
    this.backgroundColor = this.backgroundColor === 'red' ? 'blue' : 'red';
  }

  cancelCropping() {
    // Logic to cancel cropping and reset the cropper
     this.imageSize=false;
     this.fileError=false;
    this.resetCropper();
  }
  public croppedImageFile: File | null = null;

  resetCropper() {
    this.imageChangedEvent = null;
    this.showCropper = false;
    this.croppedImage = '';
    this.imageId = '';
    this.croppedImageFile = null;
  }

  private base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  public saveCroppedImage() {
    if (!this.croppedImageFile) {
      alert('No cropped image available to save.');
      return;
    }

    if (this.croppedImageFile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result; // Set the image preview
      };
      // reader.readAsDataURL(file); // Convert the file to base64 URL
    }

    const code = this.imageCode;
    const imageId = this.imageId ?? 0;
    const url =
      this.locator.getEndpoint('endpoint.user') +
      '/cuickdev/user/doc/' +
      this.form.data['id'] +
      '/' +
      imageId +
      '/' +
      code;

    const param = {
      id: this.form.data.id,
    };

    this.locator.http.postMutipart(
      url,
      param,
      this.croppedImageFile,
      (res: any, error: any) => {
        if (error) {
          alert(error);
          return;
        }
        this.form.error = !res.success;
        this.form.message = res.result.message;
        if (res.success) {
          this.form.message = 'File is uploaded successfully.';
          this.form.data[code] = res.result.data[code];
          this.changeDoc();
          this.getDocThumbnail(this.form.data[code]);
        }
      }
    );

    this.resetCropper();
  }

  public imageId: any = 0;
  public imageCode: any;
  public imageName: any;
  /**
   * Upload Image
   * @param event
   * @param code
   * @param imageId
   */

  fileError: boolean = false;
  onFileChooseClicked() {
    this.fileError=false;
   this.imageSize=false;
    this.croppedImageFile=null;
    this.imagePreview=null;
    this.imageChangedEvent = null;
    this.imageURL = '';
    this.croppedImage = '';
    this.showCropper = false;
    this.canvasRotation=0;

    this.transform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
      translateV: 0,
  };
  }

  imageSize:boolean=false;

  public onFileChanged(event: any, code: string, imageId: any) {
       const file = event.target.files[0];

       if (file) {
         // Check the file type
      const allowedTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
      ];
         
         if (!allowedTypes.includes(file.type)) {
           this.fileError = true;
           return;
      }
    }
         const maxSize = 1 * 1024 * 1024;
         if (file.size > maxSize) {
               this.imageSize=true;
               this.croppedImageFile=null;
             return;
         }
    this.fileChangeEvent(event);

    if (imageId === null || imageId === undefined) {
      imageId = 0;
      // alert(imageId);
    }
    const fileObj = event.target.files[0];
    this.imageName = fileObj['name'];
    this.imageId = imageId;
    this.imageCode = code;
  }

  resetFileInput(fileInput: HTMLInputElement): void {
    fileInput.value = ''; // Reset the file input
    this.imageName = null; // Clear the file name
    this.imageSize=false;
    console.log('File input reset');
  }

  reloadApplication() {
    (window as any).location.reload();
  }

    sharedata() {
    this.shareService.updateSharedData(
      'name',
      this.form?.data.firstName + ' ' + this.form?.data.lastName
    );
     this.shareService.updateSharedData('imageId', this.form?.data.imageId);
  }

  override save(callback?: any): void {
    super.save();
    this.sharedata();
  }
  override getDocThumbnail(skey: number) {
    if (!skey) {
      skey = 0;
    }
    let docAPI = this.locator.config.get('DOC_API');
    return docAPI + 'th/' + skey + '?t=' + this.imageTimestamp;
  }
  
  resetProfileImage() {
    this.imagePreview = null;
    this.form.data['imageId'] = null;
    this.form.data['imageId'] = 0;
  }
    
}